// Language configuration
export type LanguageCode = 'en' | 'es' | 'fr' | 'de' | 'sv' | 'ar';

export interface Language {
  code: LanguageCode;
  label: string;
  flag: string;
  direction: 'ltr' | 'rtl';
  locale: string;
}

export const languages: Language[] = [
  { code: 'en', label: 'English', flag: '🇬🇧', direction: 'ltr', locale: 'en-GB' },
  { code: 'es', label: 'Español', flag: '🇪🇸', direction: 'ltr', locale: 'es-ES' },
  { code: 'fr', label: 'Français', flag: '🇫🇷', direction: 'ltr', locale: 'fr-FR' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪', direction: 'ltr', locale: 'de-DE' },
  { code: 'sv', label: 'Svenska', flag: '🇸🇪', direction: 'ltr', locale: 'sv-SE' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦', direction: 'rtl', locale: 'ar-SA' },
];

export const defaultLanguage: LanguageCode = 'en';

export const getLanguageByCode = (code: string): Language | undefined => {
  return languages.find(lang => lang.code === code);
};

export const isRTL = (code: LanguageCode): boolean => {
  const lang = getLanguageByCode(code);
  return lang?.direction === 'rtl';
};

// Items excluded from translation
export const excludeFromTranslation = [
  'Aureum VII Trading',
  'LUXA', 'LUNA', 'ARIA', 'NOVA', 'AURELIUS', 'AURELUX', 'VENA', 'LUMA',
  'M3', 'S1', 'U1', 'K2', 'L1',
  'M80', 'M9', 'H60', 'M80F'
];
